
<ng-container *ngIf="relationType == 'P2PFullTrx'">
  <div *ngIf="documentList">
    <ng-container *ngFor="let document of documentList;let first = first; let last = last">
      <div [ngClass]="{'tab-container': true, 'tab-container-current': document.IsSelected}" (click)="getRelatedDocument(relationType,templates);" title="Show Related Document">
        <div class="tab-image">
          <ng-container *ngIf="first; else middle">
            <img [src]="document.IsSelected ?  '../../assets/images/first-arrow-tab-selected.png' : '../../assets/images/first-arrow-tab.png'" />
          </ng-container>
          <ng-template #middle>
            <ng-container *ngIf="!last && !first; else final">
              <img [src]="document.IsSelected ?  '../../assets/images/middle-arrow-tab-selected.png' : '../../assets/images/middle-arrow-tab.png'" />
            </ng-container>
          </ng-template>
          <ng-template #final>
            <ng-container *ngIf="!first && last;">
              <img [src]="document.IsSelected?  '../../assets/images/last-arrow-tab-selected.png' : '../../assets/images/last-arrow-tab.png'" />
            </ng-container>
          </ng-template>
        </div>
        <span class="text-over-image">{{document.ImageName}}</span>
      </div>
    </ng-container>
      <!-- <div [ngClass]="{'tab-container': true, 'tab-container-current': documentTypeCode == 'PO'}" (click)="getRelatedDocument(relationType,templates);" title="Show Related Document"><div class="tab-image"><img [src]="documentTypeCode == 'PO' ?  '../../assets/images/middle-arrow-tab-selected.png' : '../../assets/images/middle-arrow-tab.png'" /></div><span class="text-over-image">Orders</span></div>
      <div [ngClass]="{'tab-container': true, 'tab-container-current': documentTypeCode == 'SN'}" (click)="getRelatedDocument(relationType,templates);" title="Show Related Document"><div class="tab-image"><img [src]="documentTypeCode == 'SN' ?  '../../assets/images/middle-arrow-tab-selected.png' : '../../assets/images/middle-arrow-tab.png'" /></div><span class="text-over-image">Delivery</span></div>
      <div [ngClass]="{'tab-container': true, 'tab-container-current': documentTypeCode == 'IV'}" (click)="getRelatedDocument(relationType,templates);" title="Show Related Document"><div class="tab-image"><img [src]="documentTypeCode == 'IV' ?  '../../assets/images/last-arrow-tab-selected.png' : '../../assets/images/last-arrow-tab.png'" /></div><span class="text-over-image">Invoices</span></div>    -->   
   
  </div>
</ng-container>
<div *ngIf="relationType == 'ProgressFlow'" class="progress-flow-container">
  <div class="banner"></div>
  <div *ngIf="documentList">
    <div class="wrap">
      <div class="transaction-progress">
        <div *ngFor="let document of documentList;let i=index;" class="progress-item" [ngStyle]="{'flex': '0 0 ' + 100 / documentList.length + '%'}">
          <div class="item-container" [class.active]="document.IsSelected" [class.full-active]="document.IsFullSelected">
            <ng-container *ngIf="document.ImageName  == 'Bank'">
              <img [src]="document.IsSelected ?  '../../assets/images/new-bank-white.png' : '../../assets/images/new-bank-grey.png'">
            </ng-container>
            <ng-container *ngIf="document.ImageName  == 'Doc'">
                <img [src]="document.IsSelected ?  '../../assets/images/new-doc-white.png' : '../../assets/images/new-doc-grey.png'">
            </ng-container>
            <ng-container *ngIf="document.ImageName  == 'LO'">
                <img [src]="document.IsSelected ?  '../../assets/images/new-offer-letter-white.png' : '../../assets/images/new-offer-letter-grey.png'">
            </ng-container>
            <div class="md-step-bar-left"></div>
            <div class="md-step-bar-right"></div>
          </div>
          <div class="md-step-bar-title" *ngIf="document.Title">{{document.Title}}</div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-container *ngIf="relationType == 'PRToProduct'">
  <span (click)="getRelatedDocument(relationType,templates);" title="Show Related Document" style="cursor: pointer; margin-left: 10px">
      <img src="../../assets/images/related_ic.png" width="14" height="14">
  </span>
</ng-container>     
<!-- <span>
  <input type="button" class="btn btn-primary mr-1 button-action" value="Related Document" (click)="getRelatedDocument(template);"/>
</span> -->

<ng-template #templates>
  <div class="modal-header" *ngIf="relatedDocumentObject">
    <h6 class="modal-title"><span>Related Documents For Purchase Requisition</span></h6>
    <button type="button" class="close close-modal" data-dismiss="modal" aria-label="Close" (click)="onDecline()">
      <span aria-hidden="true" style="font-size: 25px;">&times;</span>
    </button>
  </div>
  <div class="modal-body custom-scrollbar popup-body">
      <div class="mb-related-doc-container">
        <div class="container-fluid main-container">
          <div class="row">
            <div class="col-md" *ngFor="let level of levels" style="padding: 10px">
              <div class="level">
                <p class="level-title">{{level.HeaderDisplay}}</p>
                  <ng-container *ngFor="let document of getLevelDocument(level.DocumentType)">
                    <ng-container *ngIf="!document.Properties;else access">
                      <div [ngClass]="{'horizontalCard': true, 'highlight': document.Highlight, 'green-bg' : selectedDoc == document.DocumentId, 'grey-bg' : true }"
                      (click)="highlightDirectRelated(document.DocumentType, document.DocumentId)"> 
                        <div class="col-12">
                          <p class="cardDisabled">
                            <img src="../../assets/images/lockIcon-white.png" width="13" height="19" style="margin-right: 10px;">
                            You have no access
                          </p>
                        </div>
                      </div>
                    </ng-container>
                    <ng-template #access>
                      <div [ngClass]="{'horizontalCard': true, 'highlight': document.Highlight, 'green-bg' : selectedDoc == document.DocumentId }"
                      (click)="highlightDirectRelated(document.DocumentType, document.DocumentId)"> 
                        <div class="col-8">
                          <p class="cardMiniSubtitle clamp-1">{{document.Properties.prop1}}</p>
                          <p class="cardMiniSubtitle clamp-1" style="padding-right: 0px;" title="{{ document.DocumentType }}">{{document.Properties.prop2}}</p>
                          <p class="cardBodyCopy clamp-1">{{document.Properties.prop3}}</p>
                        </div>
                        <div class="col-4" style="padding-left: 0;padding-right: 10px;">
                          <p class="cardDesc">{{document.Properties.prop4 | date:'dd MMM yyyy'}}</p>
                          <p class="cardDesc2">{{document.Properties.prop5}}</p>
                        </div>
                        <span class="relatedDocIcon" (click)="showRelatedDocument(document.DocumentType, document.DocumentId)" title="Show Document">
                          <img src="../../assets/images/show_ic.png" width="16" height="16">
                        </span>
                      </div>
                    </ng-template>
                  </ng-container>
                </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</ng-template>
